import React from "react";

export interface TitleProps {
    badge?: string;
    title?: string;
    subtitle?: string;
    className?: string;
}

export const Title: React.FC<TitleProps> = ({
    badge = "",
    title = "",
    subtitle = "",
    className = "",
}) => {
    if (!badge && !title && !subtitle) {
        return null;
    }

    return (
        <div
            className={`text-center mx-auto mb-4 bg-white rounded-2xl w-full border border-slate-200/80 p-5 shadow-xs ${className}`}
        >
            {badge && (
                <span className="px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest text-[#810000] bg-red-50 border border-red-200 rounded-full shadow-2xs inline-block mb-2">
                    {badge}
                </span>
            )}
            {title && (
                <h2 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">
                    {title}
                </h2>
            )}
            {subtitle && (
                <p className="text-xs text-slate-500 mt-1 max-w-xl mx-auto">
                    {subtitle}
                </p>
            )}
        </div>
    );
};

export default Title;
